<template>
  <div class="row h-100">

    <div class="container text-left mt-5 align-self-center">

      <div class="page-header my-5 text-center">
        <h2>Configuration Page</h2>
      </div>

      <form class="mt-5">
        <div class="accordion offset-lg-2 col-lg-8" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <h4>Basic<img alt="logo Fulcri" src="../assets/arrow.svg" height="15px"></h4>
                </button>
              </h2>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body py-5 px-4">
                <div class="form-group row">
                  <label for="idUser" class="col-sm-4 col-form-label">Id User</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="idUser" v-model="json.idUser"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="apiToken" class="col-sm-4 col-form-label">Token API</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="apiToken" v-model="json.apiToken"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="videoTerminal" class="col-sm-4 col-form-label">Video Terminal</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="videoTerminal" v-model="json.videoTerminal"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <h4><img alt="logo Fulcri" src="../assets/arrow.svg" height="15px">Advanced</h4>
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body py-5 px-4">
                <div class="form-group row">
                  <label for="apiUrl" class="col-sm-4 col-form-label">Url API</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="apiUrl" v-model="json.apiUrl"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="videoVersion" class="col-sm-4 col-form-label">Video Version</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="videoVersion" v-model="json.videoVersion"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="offset-2 col-sm-4 d-flex justify-content-start mt-5">
            <router-link class="spacing" to="/">
              <button class="btn btn-outline-primary mr-2 cta-left" type="button">Home</button>
            </router-link>
          </div>
          <div class="col-sm-4 d-flex justify-content-end mt-5">
            <button class="btn btn-outline-primary mr-2" type="button" v-on:click="resetFile(json)">Reset</button>
            <button class="btn btn-primary cta-right" type="button" v-on:click='saveFile(json)'>Save</button>
          </div>
        </div>
      </form>
    </div>
    <div class="logo">
      <img alt="logo Fulcri" src="../assets/logo-fulcri-neg.svg" height="40px">
    </div>
  </div>
</template>

<script>
  import {saveFile, resetFile} from '../utility'

  export default {
    name: "Config",
    // components: 'config',

    data() {
      return {
        json: {
          apiUrl: null,
          idUser: null,
          apiToken: null,
          videoVersion: null,
          videoTerminal: null,
        }
      };
    },

    mounted() {
      var js = JSON.parse(window.localStorage.getItem("jso"));
      if (js != null) {
        if (js.idUserj != null) {
          this.json.idUser = js.idUserj;
        } else {
          this.json.idUser = "";
        }
        if (js.apiUrlj != null) {
          this.json.apiUrl = js.apiUrlj;
        } else {
          this.json.apiUrl = "https://web2.pharmafulcri.it/api/v1";
        }
        if (js.apiTokenj != null) {
          this.json.apiToken = js.apiTokenj;
        } else {
          this.json.apiToken = "";
        }
        if (js.videoVersionj != null) {
          this.json.videoVersion = js.videoVersionj;
        } else {
          this.json.videoVersion = "V3";
        }
        if (js.videoTerminalj != null) {
          this.json.videoTerminal = js.videoTerminalj;
        } else {
          this.json.videoTerminal = "";
        }
      } else {
        this.json.idUser = "";
        this.json.apiUrl = "https://web2.pharmafulcri.it/api/v1";
        this.json.apiToken = "";
        this.json.videoVersion = "V3";
        this.json.videoTerminal = "";
      }
    },

    methods: {
      saveFile,
      resetFile,
    }
  };
</script>
